import React, { FC } from "react";
import mergeClasses from "classnames";
import useStyles from "./styles";

export type DPSpacerProps = {
  className?: string;
  grow?: number;
  spacing?: number;
  shrink?: number;
};

const DPSpacer: FC<DPSpacerProps> = ({
  className,
  grow,
  spacing = 1,
  shrink,
}) => {
  const classes = useStyles({ grow, spacing, shrink });
  const spacerClassName = mergeClasses(classes.spacer, className);
  return <div className={spacerClassName} />;
};

export default DPSpacer;
